import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { MIDDLE_WARE_BASE_URL_v1, CALL_PPOR_API } from "../../../../utils/CONSTANTS";
import axios from "../../../../utils/axios";


const initialState = {
    status: '',
    state: '',
    attachmentData: null
};

export const attachment = createAsyncThunk("post/getAttachment", async (data: any) => {
    const response = axios.postStringRequest(MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(), data.input);
    return response;
});

export const attachmentSlice = createSlice({
    name: 'getAttachment',
    initialState,
    reducers: {},
    extraReducers: (builder: any) =>
        builder
            .addCase(attachment.pending, (state: any) => {
                state.state = 'pending';

            })
            .addCase(attachment.fulfilled, (state: any, action: any) => {
                let json = JSON.stringify(action?.payload?.data?.response);
                json = json.replace(/\\"/gi, '"').replace('"{', "{").replace('}"', '}');
                const parsedResponse = JSON.parse(json);
                state.attachmentData = parsedResponse?.response;
                state.state = 'fulfilled';
            })
            .addCase(attachment.rejected, (state: any) => {
                state.state = 'failed';
            })
});

export const selectAttachment = ((state: any) => state.attachment || {});

export default attachmentSlice.reducer;
